export default __webpack_public_path__ + "static/media/closet5-before3-1024w.54974426.webp";